module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "case"
  }, [_c('p', [_vm._v("请上传案例文件：")]), _vm._v(" "), _c('p', [_vm._v("有案例的上传案例，没有案例的可以上传应急预案或风险评估报告里的情景模拟内容")]), _vm._v(" "), _c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "action": "/api/emer/plancase/upload",
      "headers": _vm.headers,
      "on-success": _vm.handleSuccess,
      "on-error": _vm.handleError,
      "on-remove": _vm.handleRemove,
      "data": _vm.datalist,
      "file-list": _vm.fileList
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    }
  }, [_vm._v("点击上传")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-48c08f02","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/burst/case.vue
// module id = 1220
// module chunks = 2